module.exports = __webpack_public_path__ + "img/using-buynow.75a9d930.png";